const initOpenCloseAccordion = () => {
    const insightsListWidgetsArray = document.querySelectorAll(".insights-list-widget");
    if (insightsListWidgetsArray && insightsListWidgetsArray.length > 0) {
        insightsListWidgetsArray.forEach((insightsListWidget) => {
            const accordionsInsightsListArray = insightsListWidget.querySelectorAll(".accordion-insights-list");
            accordionsInsightsListArray.forEach((accordionInsightsList) => {
                const plus = accordionInsightsList.querySelector(".plus");
                const minus = accordionInsightsList.querySelector(".minus");
                const titleAccordionInsightsList = accordionInsightsList.querySelector(".title-accordion-insights-list");
                const descriptionAccordionInsightsList = accordionInsightsList.querySelector(".description-accordion-insights-list");
                clickBehaviourOneCloseAccordion(titleAccordionInsightsList, plus, minus, descriptionAccordionInsightsList);
                clickBehaviourOneCloseAccordion(plus, plus, minus, descriptionAccordionInsightsList);
                clickBehaviourOneCloseAccordion(minus, plus, minus, descriptionAccordionInsightsList);
            });
        });
    }
};
const clickBehaviourOneCloseAccordion = (clickElement, plus, minus, description) => {
    clickElement.addEventListener("click", () => {
        if (minus.classList.contains("active")) {
            minus.classList.remove("active");
            description.classList.remove("active");
            plus.classList.add("active");
        }
        else {
            plus.classList.remove("active");
            minus.classList.add("active");
            description.classList.add("active");
        }
    });
};
